import { z } from "zod";

export const localizationSchema = z.object({
  city: z.optional(z.string().max(255, "Nazwa miasta jest zbyt długa")),
  postalCode: z.optional(z.string().max(255, "Kod pocztowy jest zbyt długi")),
  streetAddress: z.optional(z.string().max(255, "Nazwa ulicy jest zbyt długa")),
});
